import React, { createContext, useContext, useState, useCallback } from 'react';

interface ModelImageContextValue {
    modelImageUrl: string | undefined;
    setModelImageUrl: (url: string | undefined) => void;
    isUploading: boolean;
    setIsUploading: (uploading: boolean) => void;
    bodyFullFrontImage: string | null;
    setBodyFullFrontImage: (url: string | null) => void;
}

const ModelImageContext = createContext<ModelImageContextValue | undefined>(undefined);

export const ModelImageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [modelImageUrl, setModelImageUrl] = useState<string | undefined>(undefined);
    const [isUploading, setIsUploading] = useState<boolean>(false);
    const [bodyFullFrontImage, setBodyFullFrontImage] = useState<string | null>(null);

    const updateModelImageUrl = useCallback((url: string | undefined) => {
        setModelImageUrl(url);
    }, []);

    const contextValue: ModelImageContextValue = {
        modelImageUrl,
        setModelImageUrl: updateModelImageUrl,
        isUploading,
        setIsUploading,
        bodyFullFrontImage,
        setBodyFullFrontImage,
    };

    return <ModelImageContext.Provider value={contextValue}>{children}</ModelImageContext.Provider>;
};

export const useModelImage = (): ModelImageContextValue => {
    const context = useContext(ModelImageContext);
    if (context === undefined) {
        throw new Error('useModelImage must be used within a ModelImageProvider');
    }
    return context;
};
